import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const SaveBookmarkIcon: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g {...(props.group ?? {})}>
      <path
        d="M32.8614 16.6474C30.0411 13.8271 26.3005 12.271 22.3131 12.271C18.3257 12.271 14.5777 13.8271 11.7573 16.6474C8.93693 19.4678 7.38086 23.2158 7.38086 27.2032C7.38086 31.1907 8.93693 34.9387 11.7573 37.7591C14.5777 40.5794 18.3257 42.1355 22.3131 42.1355C26.3005 42.1355 30.0486 40.5794 32.8689 37.7591C35.6893 34.9387 37.2454 31.1907 37.2454 27.2032C37.2454 23.2158 35.6818 19.4678 32.8689 16.6549L32.8614 16.6474ZM34.6045 27.1958C34.6045 30.48 33.3253 33.5622 30.9987 35.8813C28.6795 38.2004 25.5973 39.4797 22.3131 39.4872C19.0289 39.4872 15.9467 38.2079 13.6201 35.8888C11.3009 33.5697 10.0217 30.48 10.0217 27.1958C10.0217 23.9116 11.3009 20.8294 13.6201 18.5027C15.9392 16.1836 19.0289 14.9043 22.3131 14.9043C25.5973 14.9043 28.7169 16.2135 31.0061 18.5027C33.3253 20.8219 34.6045 23.9116 34.6045 27.1958Z"
        fill={fillColor}
      />
      <path
        d="M29.8234 25.879H23.6365V19.6847C23.6365 18.959 23.0381 18.3755 22.3199 18.3755C21.6017 18.3755 21.0032 18.9665 21.0032 19.6922V25.8865H14.8089C14.0832 25.8865 13.4922 26.4775 13.4922 27.2032C13.4922 27.9288 14.0832 28.5198 14.8089 28.5198H21.0032V34.7067C21.0032 35.0583 21.1453 35.4024 21.3847 35.6418C21.6316 35.8887 21.9683 36.0309 22.3199 36.0309C22.6715 36.0309 23.0007 35.8962 23.255 35.6418C23.5019 35.395 23.6365 35.0583 23.6365 34.7067V28.5198H29.8234C30.5491 28.5198 31.1401 27.9288 31.1401 27.2032C31.1401 26.4775 30.5491 25.8865 29.8234 25.8865V25.879Z"
        fill={fillColor}
      />
      <path
        d="M49.4393 0.952637H8.59256C3.88696 0.952637 0.0566406 4.79043 0.0566406 9.48856V13.5283C0.0566406 14.2839 0.67009 14.8974 1.42568 14.8974C2.1289 14.8974 2.69746 14.3288 2.69746 13.6256V9.48856C2.69746 6.23428 5.34577 3.59346 8.60004 3.58598H43.7312C42.5791 4.93258 41.9283 6.66819 41.9358 8.45617V70.422L23.263 51.1881C22.7692 50.6719 21.864 50.6794 21.3703 51.1881L2.68998 70.4295V22.4608C2.68998 21.7276 2.0915 21.1291 1.35835 21.1291C0.625203 21.1291 0.0566406 21.7127 0.0566406 22.4308V73.6763C0.0566406 74.2149 0.378327 74.6937 0.87956 74.9032C1.38079 75.1052 1.94936 74.9855 2.32341 74.5965L22.3129 54.0085L42.3023 74.5965C42.3023 74.5965 42.7288 74.9256 42.9457 74.963C43.1627 75.0005 43.4844 75.0079 43.7462 74.9032C44.2474 74.7012 44.5691 74.2149 44.5691 73.6838V30.2635H55.6262C56.3518 30.2635 56.9428 29.6725 56.9428 28.9469V8.45617C56.9428 4.32661 53.5763 0.952637 49.4393 0.952637ZM52.8282 4.9625C53.7783 5.89015 54.302 7.13202 54.302 8.45617V27.6152H44.5616V8.6806C44.5616 5.95748 46.6788 3.67575 49.2822 3.59346C50.6064 3.54109 51.8707 4.04233 52.8208 4.9625H52.8282Z"
        fill={fillColor}
      />
      <path
        d="M1.37331 16.4536C0.647647 16.4536 0.0566406 17.0446 0.0566406 17.7703V18.4286C0.0566406 19.1543 0.647647 19.7453 1.37331 19.7453C2.09898 19.7453 2.68998 19.1543 2.68998 18.4286V17.7703C2.68998 17.0446 2.09898 16.4536 1.37331 16.4536Z"
        fill={fillColor}
      />
    </g>
  );
};

export const SaveBookmarkIconSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="57"
      height="75"
      viewBox="0 0 57 75"
      fill="none"
      {...(props.svg ?? {})}
    >
      <SaveBookmarkIcon {...props} />
    </svg>
  );
};
